'use client';

import { formatCurrencyWithCode } from '@/lib/utils';
import useCurrency from '@/hooks/useCurrency';

export default function Price({
  price,
  className,
  currency,
}: {
  price: number;
  className?: string;
  currency?: string;
}) {
  const { selectedCurrencyObject } = useCurrency();

  return (
    <span className={className}>
      {formatCurrencyWithCode(price, currency || selectedCurrencyObject?.code)}
    </span>
  );
}
